/* eslint-disable global-require */
import React from 'react';

import Head from 'next/head';
import Article from '../../Components/Article';
import FeaturedContentTwo from '../../Components/FeaturedContentTwo';
import LearnMore from '../../Components/LearnMore';
import Navbar from '../../Components/Navbar';
import WantToLearnMore from '../../Components/WantToLearnMore';
import Footer from '../../Components/Footer';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Proctortrack from '../../Components/Proctortrack';
import Solution from '../../Components/Solution';
import Level from '../../Components/Level';

class RemoteProctoring extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">Edvice</title>
          <meta content="Edvice" key="og:title" property="og:title" />
          <meta content="Edvice" key="description" name="description" />
          <meta content="Edvice" key="og:description" property="og:description" />
        </Head>

        <Navbar>Navbar</Navbar>
        <div className="feature">
          <DigitalDisplay
            color="red"
            image={require('./laptop-image.png')}
            column="col-xs-10 col-xs-offset-0 col-sm-5 col-sm-offset-2"
          >
            <Article>
              <header className="remote__header" id="remote">
                <h2>
                  <strong>What is Remote Proctoring?</strong>
                </h2>
              </header>
              <section className="remote__section">
                <p>
                  Remote proctoring is a service that emulates the role of an on-site proctor –
                  confirming the identity of the test-taker and safeguarding the integrity of the
                  exam – using an internet-delivered or phone-delivered assessment monitored by our
                  offsite proctor.
                </p>
              </section>
            </Article>
          </DigitalDisplay>
        </div>
        <Proctortrack />
        <Solution />
        <FeaturedContentTwo color="black" left image={require('./2.png')}>
          <Article>
            <header className="article__header">
              <h2>For Institutions</h2>
            </header>
            <section className="article__section">
              <div className="flex-items">
                <img alt="" src={require('./01.png')} />
                <div>
                  <h3>Meet Accreditation Requirements</h3>
                  <p>Achieve DOE Title IV compliance with ID verification and remote proctoring.</p>
                </div>
              </div>
              <div className="flex-items">
                <img alt="" src={require('./02.png')} />
                <div>
                  <h3>Protect your Brand</h3>
                  <p>
                    Demand integrity from students and improve your school’s competitive standing.
                  </p>
                </div>
              </div>
              <div className="flex-items">
                <img alt="" src={require('./03.png')} />
                <div>
                  <h3>FERPA Compliant</h3>
                  <p>Choose a secure solution that values privacy and safeguards data.</p>
                </div>
              </div>
              <div className="flex-items">
                <img alt="" src={require('./04.png')} />
                <div>
                  <h3>Competitive Low Pricing</h3>
                  <p>Replicate the security of a testing center at a fraction of the cost.</p>
                </div>
              </div>
            </section>
          </Article>
        </FeaturedContentTwo>
        <FeaturedContentTwo right color="red" image={require('./1.png')}>
          <Article>
            <header className="article__header" id="remote">
              <h2>For Students</h2>
            </header>
            <section className="article__section">
              <div className="flex-items">
                <img alt="" src={require('./05.png')} />
                <div>
                  <h3>Test at your Convenience</h3>
                  <p>
                    Take your exam from the comforts of home, with no advanced scheduling required.
                  </p>
                </div>
              </div>
              <div className="flex-items">
                <img alt="" src={require('./06.png')} />
                <div>
                  <h3>Non Intrusive Approach</h3>
                  <p>Remove the manual element for a more comfortable proctoring experience.</p>
                </div>
              </div>
              <div className="flex-items">
                <img alt="" src={require('./07.png')} />
                <div>
                  <h3>Easy to use</h3>
                  <p>Simply launch the app from inside your LMS to take a proctored exam.</p>
                </div>
              </div>
              <div className="flex-items">
                <img alt="" src={require('./08.png')} />
                <div>
                  <h3>Excel with Integrity</h3>
                  <p>Emerge from a level playing-field with a more valuable degree. </p>
                </div>
              </div>
            </section>
          </Article>
        </FeaturedContentTwo>
        <Level />
        <LearnMore />
        <WantToLearnMore />
        <Footer />
      </React.Fragment>
    );
  }
}
export default RemoteProctoring;
